import { ISelect } from "../../interfaces/select";
import Spinner from "../atoms/spinnerV2";

const SelectSheet = (props: ISelect) => {
  return (
    <>
      <select
        {...props}
        className={`mt-3 form-select ${props.required ? `select-form-error` : ``}`}
        aria-label="select default "
        style={{ height: "55px" }}
      >
        <option key="EMPTY" value="EMPTY">
          {props.placeholder}
        </option>
        {props.data.map((memo) => {
          return (
            <option key={memo.value + memo.label} value={memo.value}>
              {memo.label}
            </option>
          );
        })}
      </select>
      {props.error && <small className="block dangerous-red">{props.error}</small>}
    </>
  );
};

export default SelectSheet;
